<div class="home">
  @if (!seenReleaseNotes) {
  <div class="releases-container">
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header class="expansion-panel-header">
        <div class="expansdiv">
          <div class="text">See What's New</div>
          <div class="acknowledge">
            <button mat-raised-button class="acknowledge-button" (click)="acknowledgeReleaseNotes($event)">Acknowledge</button>
            <button mat-button (click)="GoToPage(RELEASES); $event.stopPropagation()" color="navigator">View Releases</button>
          </div>
        </div>
      </mat-expansion-panel-header>
      <div class="release-wrapper">
        <div class="preview-wrapper">
          <div [innerHtml]="releasesHtml.header" class="header"></div>
          <div style="text-align: left" [innerHtml]="releasesHtml.body" class="content"></div>
        </div>
      </div>
    </mat-expansion-panel>
  </div>
  }
  <div class="main-container">
    @for (route of this.getNavRoutes(); track route) {
    <mat-card class="card-container" (click)="GoToPage(route.route)">
      <div class="image-wrapper">
        <img [src]="route.imgSrc" />
      </div>
      <div class="content-wrapper">
        <div class="title-wrapper">
          <mat-card-title class="card-title">{{ route.title }}</mat-card-title>
          <mat-card-subtitle class="card-description">{{ route.description }}</mat-card-subtitle>
        </div>
        <button mat-raised-button color="navigator">View</button>
      </div>
    </mat-card>
    }
  </div>
</div>
